
import { Progress } from "@/components/ui/progress";

type UsageProgressBarProps = {
  label: string;
  current: number;
  max: number;
  showUnlimited?: boolean;
}

export const UsageProgressBar = ({ label, current, max, showUnlimited = false }: UsageProgressBarProps) => {
  const isUnlimited = max === Infinity || showUnlimited;
  const percentage = isUnlimited ? 100 : Math.min((current / max) * 100, 100);
  
  return (
    <div className="space-y-2">
      <div className="flex justify-between text-[13px]">
        <span className="text-black font-bold">{label}</span>
        <span className="font-medium text-gray-900">
          {current}/{isUnlimited ? "∞" : max}
        </span>
      </div>
      <Progress 
        value={percentage}
        className={`h-1.5 ${isUnlimited ? "bg-green-100" : ""}`}
      />
    </div>
  );
};
